<template>
  <van-popup
    v-model:show="visible"
    position="bottom"
    class="setfont-popup"
  >
    <div class="set-wrap">
      <div class="set-header">
        <div class="title">字号设置</div>
        <div
          class="confirm-btn"
          @click="emit('close')"
        >
          确定
        </div>
      </div>
      <div class="slide-wrap">
        <van-slider
          v-model="percentage"
          active-color="#EB2E2E"
          inactive-color="#dcdee0"
          :min="0"
          :max="100"
          @update:model-value="onSliderChange"
        >
          <template #button>
            <div class="custom-slider-button"></div>
          </template>
        </van-slider>
      </div>
      <div class="set-cell">
        <div
          v-for="(item, index) in fontOptions"
          :key="item.size"
          class="u-item-wrap"
        >
          <div
            @click="setFontSize(item.size)"
            :class="[
              'fs-' + item.size,
              'u-item',
              { active: setSize === item.size }
            ]"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script setup>
import {
  Popup as VanPopup,
  Slider as VanSlider,
  Button as VanButton
} from "vant";
import { onMounted, defineOptions, ref, watch, nextTick } from "vue";
// 定义组件名称
defineOptions({
  name: "FontSettingPopup"
});

const emit = defineEmits(["close", "update:show"]);

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
});

const visible = ref(props.show);

const fontOptions = [
  { size: 16, label: "小", point: 0 },
  { size: 18, label: "标准", point: 32 },
  { size: 20, label: "大", point: 64 },
  { size: 22, label: "特大", point: 100 }
];
const setSize = ref(18);

// 当前滑块的百分比位置 (0-100)
const percentage = ref(32);

// 监听 setSize 变化同步滑块百分比
watch(setSize, (newSize) => {
  const option = fontOptions.find((opt) => opt.size === Number(newSize));
  if (option) {
    percentage.value = option.point;
  }
});

watch(
  () => props.show,
  (val) => {
    visible.value = val;
    if (val) {
      // 弹窗弹出时，从localStorage获取最新字号并同步
      const fontSize = localStorage.getItem("zsplus-fontSize");
      if (fontSize) {
        const size = Number(fontSize);
        setSize.value = size;
        const option = fontOptions.find((opt) => opt.size === size);
        if (option) {
          percentage.value = option.point;
        }
      }
    }
  }
);

watch(visible, (val) => {
  emit("update:show", val);
  if (!val) {
    emit("close");
  }
});

const contentEl = document.querySelector(".app-main-content");
const summaryEl = document.querySelector(".summary-box");
const setFontSize = (size) => {
  console.log("设置字体大小:", size);
  setSize.value = size;
  // 设置字体大小，设置类为 content 的字体大小为 size px
  if (contentEl) {
    contentEl.style.fontSize = `${size}px`;
    // 将字体大小缓存到localStorage
    localStorage.setItem("zsplus-fontSize", size);
  }
  if (summaryEl) {
    summaryEl.style.fontSize = `${size - 2}px`;
    const summaryOrderEls = summaryEl.querySelectorAll(".u-summary-order");
    summaryOrderEls.forEach((el) => {
      el.style.fontSize = `${size - 4}px`;
    });
  }
};

const onSliderChange = (value) => {
  // 寻找最接近的预设点进行吸附
  const closest = fontOptions.reduce((prev, curr) => {
    return Math.abs(curr.point - value) < Math.abs(prev.point - value)
      ? curr
      : prev;
  });

  percentage.value = closest.point;
  setSize.value = closest.size;

  // 滑动过程中也可以实时改变字体大小
  if (contentEl) {
    contentEl.style.fontSize = `${closest.size}px`;
    setFontSize(closest.size);
  }
  if (summaryEl) {
    summaryEl.style.fontSize = `${closest.size - 2}px`;
    const summaryOrderEls = summaryEl.querySelectorAll(".u-summary-order");
    summaryOrderEls.forEach((el) => {
      el.style.fontSize = `${closest.size - 4}px`;
    });
    setFontSize(closest.size);
  }
};

defineExpose({
  setFontSize
});
</script>

<style lang="scss">
.setfont-popup {
  width: 90%;
  margin: 5%;
  border-radius: 16px;
  text-align: left;
  .set-wrap {
    padding: 20px;
    border-radius: 16px;
    box-sizing: border-box;
  }
  .set-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .confirm-btn {
      height: 24px;
      line-height: 25px;
      font-size: 16px;
      color: #c0c4cc;
    }
  }
  .title {
    font-size: 16px;
    font-weight: 600;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .slide-wrap {
    margin-top: 24px;
    padding: 0 10px;
    margin-right: 9px;
  }
  .custom-slider-button {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #eb2e2e;
    box-shadow: 0 0 5px #eb2e2e;
  }
  .set-cell {
    margin-top: 16px;
    color: #c0c4cc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .u-item {
      white-space: nowrap;
      cursor: pointer;
    }
    .active {
      color: #eb2e2e;
    }
    .fs-16 {
      font-size: 16px;
    }
    .fs-18 {
      font-size: 18px;
    }
    .fs-20 {
      font-size: 20px;
    }
    .fs-22 {
      font-size: 22px;
    }
  }
}
</style>
